//#region src/modules/Stats/constants/echartsDarkTheme.ts
var contrastColor = "#B9B8CE";
var backgroundColor = "transparent";
var axisCommon = function() {
	return {
		axisLine: { lineStyle: { color: contrastColor } },
		minorSplitLine: { lineStyle: { color: "#20203B" } },
		splitArea: { areaStyle: { color: ["rgba(255,255,255,0.02)", "rgba(255,255,255,0.05)"] } },
		splitLine: { lineStyle: { color: "#484753" } }
	};
};
var colorPalette = [
	"#8a94ed",
	"#87f7cf",
	"#f7f494",
	"#72ccff",
	"#f7c5a0",
	"#d4a4eb",
	"#d2f5a6",
	"#76f2f2"
];
var echartsDarkTheme = {
	axisPointer: {
		crossStyle: { color: "#817f91" },
		label: { color: "#fff" },
		lineStyle: { color: "#817f91" }
	},
	backgroundColor,
	calendar: {
		dayLabel: { color: contrastColor },
		itemStyle: { color: backgroundColor },
		monthLabel: { color: contrastColor },
		yearLabel: { color: contrastColor }
	},
	candlestick: { itemStyle: {
		borderColor: "#8a94ed",
		borderColor0: "#87f7cf",
		color: "#8a94ed",
		color0: "#87f7cf"
	} },
	categoryAxis: axisCommon(),
	color: colorPalette,
	darkMode: true,
	dataZoom: {
		borderColor: "#71708A",
		brushStyle: { color: "rgba(135,163,206,0.3)" },
		dataBackground: {
			areaStyle: { color: "#71708A" },
			lineStyle: {
				color: "#71708A",
				width: 1
			}
		},
		emphasis: {
			handleStyle: {
				borderColor: "#91B7F2",
				color: "#4D587D"
			},
			moveHandleStyle: {
				color: "#636D9A",
				opacity: .7
			}
		},
		fillerColor: "rgba(135,163,206,0.2)",
		handleStyle: {
			borderColor: "#C5CBE3",
			color: "#353450"
		},
		moveHandleStyle: {
			color: "#B0B6C3",
			opacity: .3
		},
		selectedDataBackground: {
			areaStyle: { color: "#87A3CE" },
			lineStyle: { color: "#87A3CE" }
		},
		textStyle: { color: contrastColor }
	},
	gauge: { title: { color: contrastColor } },
	graph: { color: colorPalette },
	legend: { textStyle: { color: contrastColor } },
	line: { symbol: "circle" },
	logAxis: axisCommon(),
	textStyle: { color: contrastColor },
	timeAxis: axisCommon(),
	timeline: {
		controlStyle: {
			borderColor: contrastColor,
			color: contrastColor
		},
		label: { color: contrastColor },
		lineStyle: { color: contrastColor }
	},
	title: {
		subtextStyle: { color: "#B9B8CE" },
		textStyle: { color: "#EEF1FA" }
	},
	toolbox: { iconStyle: { borderColor: contrastColor } },
	valueAxis: axisCommon(),
	visualMap: { textStyle: { color: contrastColor } }
};
echartsDarkTheme.categoryAxis.splitLine.show = false;
//#endregion
export { echartsDarkTheme };

//# sourceMappingURL=echartsDarkTheme.js.map